import { connect } from 'react-redux';
import { get } from 'lodash';

import { FRFriendListLoader } from './fr-friend-list-loader.component';
import { IFRInviteeData } from '@sitegen/common/classes/friends-referral-api';

export interface IFRFriendListLoaderStoreProps {
    readonly env: string;
    readonly userId: string;
    readonly invitees: IFRInviteeData[];
}

const mapStateToProps = (state: object): IFRFriendListLoaderStoreProps => ({
    env: get(state, 'config.envName'),
    userId: get(state, 'login.loginSession.UbisoftConnectProfile.user.userId'),
    invitees: get(state, 'friendsReferral.invitees')
});

export default connect(mapStateToProps)(FRFriendListLoader);
